import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    isAuthenticated: !!localStorage.getItem('token') || false, 
    nivelUser: localStorage.getItem('nivelUser') || '',
    nome: localStorage.getItem('nome') || '',
    numeroEndereco: localStorage.getItem('numeroEndereco') || '',
    nomeEndereco: localStorage.getItem('nomeEndereco') || '',
    nomeOdonto: localStorage.getItem('nomeOdonto') || '',
    ruaEndereco: localStorage.getItem('ruaEndereco') ||'',
    nomeUnidade: localStorage.getItem('nomeUnidade') || ''
  },
  
  getters: {
    isAuthenticated: state => !!state.isAuthenticated,
    token: state => state.token,
    nome: state => state.nome,
    nivel: state => state.nivelUser,
    numeroEndereco: state => state.numeroEndereco,
    nomeEndereco: state => state.nomeEndereco,
    nomeOdonto: state => state.nomeOdonto,
    ruaEndereco: state => state.ruaEndereco,
    nomeUnidade: state => state.nomeUnidade
  },

  mutations: {
    
    LOGOUT_USER(state) {
      state.nivelUser = null
      state.token = null
      state.isAuthenticated = false
      state.nomeOdonto = ''
      state.nomeUnidade = ''
      localStorage.setItem('nomeOdonto', '')
      localStorage.setItem('nomeUnidade', '')
      localStorage.setItem("nivelUser", null)
      localStorage.setItem("token", null)
    },

    SET_CURRENT_NOME_ENDERECO(state, value){
      state.nomeEndereco = value
      localStorage.setItem('nomeEndereco', value)
    },

    SET_CURRENT_NOME_ODONTO(state, value){
      state.nomeOdonto = value
      localStorage.setItem('nomeOdonto', value)
    },

    SET_CURRENT_NOME_UNIDADE(state, value){
      state.nomeUnidade = value
      localStorage.setItem('nomeUnidade', value)
    },
    
    SET_CURRENT_RUA_ENDERECO(state, value){
      state.ruaEndereco = value
      localStorage.setItem('ruaEndereco', value)
    },

    SET_CURRENT_USER_NIVEL(state, value){
      state.nivelUser = value
      localStorage.setItem('nivelUser', value)
    },

    SET_CURRENT_TOKEN(state, token) {
      state.token = token
      localStorage.setItem("token", token)
    },

    ALTER_AUTHENTICATED_STATE(state, value){
        state.isAuthenticated = value
    },

    SET_USER_NAME(state, value){
      state.nome = value
    },

    SET_NUMERO_ENDERECO(state, value){
      state.numeroEndereco = value
      localStorage.setItem('numeroEndereco', value)
    }
  },
  actions: {

    logout({commit}) {
      commit('LOGOUT_USER');
    },

    setToken({commit}, token) {
      commit('SET_CURRENT_TOKEN', token)
    },

    setAuthenticatedState({commit}, value){
      commit('ALTER_AUTHENTICATED_STATE', value)
    },

    setNivelUsuario({commit}, value){
      commit('SET_CURRENT_USER_NIVEL', value)
    },

    setNome({commit}, value){
      commit('SET_USER_NAME', value)
    },

    setNumeroEndereco({commit}, value){
      commit('SET_NUMERO_ENDERECO', value)
    },

    setNomeEndereco({commit}, value){
      commit('SET_CURRENT_NOME_ENDERECO', value)
    },

    setNomeOdonto({commit}, value){
      commit('SET_CURRENT_NOME_ODONTO', value)
    },

    setNomeUnidade({commit}, value){
      commit('SET_CURRENT_NOME_UNIDADE', value)
    },

    setRuaEndereco({commit}, value){
      commit('SET_CURRENT_RUA_ENDERECO', value)
    }


  
  }
});

